// extracted by mini-css-extract-plugin
export var category = "index-module--category--A8GBL";
export var featured = "index-module--featured--walXO";
export var featuredImg = "index-module--featuredImg--80qWi";
export var featuredImgWrapper = "index-module--featuredImgWrapper--RAOIM";
export var textContainer = "index-module--textContainer--xXYW4";
export var title = "index-module--title--Mq3KC";